import React from "react";
import Dictionary from "./dictionary";


export default function App() {
  return (
    <div className="bg-gray-100 min-h-screen p-4">
      <Dictionary />
    </div>
  );
}
